module.exports = __webpack_public_path__ + "static/media/raid_servers_7.c5a38ea3.jpg";